import { CreateKeyValueRequest } from "@models/base/createKeyValueRequest.model"

export class CreateTareaRequest extends CreateKeyValueRequest{
  public titulo!:	string
  public fechaVencimiento!: Date | null
  public fechaInicioReal!: Date | null
  public fechaInicioEstimada!: Date | null
  public idEstadoTarea!:number
  public idTipoTarea!:number
  public idTareaPadre!:number
  public asignadoA!:number
  public autorizadoPor!:number
  public prioridad!:number | null
  public nivelAvance!:number
  public notificado!:boolean
  public idExpediente!:number
  }
